const LANG_CURRENCY = {
    en: "USD", es: "USD", pt: "BRL", fr: "EUR", de: "EUR", it: "EUR",
    zh: "CNY", ar: "USD", ja: "JPY", sv: "SEK", af: "USD",
};
const SYMBOL = {
    USD: "$", EUR: "€", BRL: "R$", JPY: "¥", CNY: "¥", SEK: "kr", GBP: "£",
};
let cache = null;
let inflight = null;
async function load() {
    if (cache && Date.now() - cache.fetched_at < 6 * 3600_000)
        return;
    if (inflight)
        return inflight;
    inflight = fetch("/api/fx").then((r) => r.json()).then((d) => {
        cache = { rates: d.rates, fetched_at: Date.now() };
        inflight = null;
    }).catch(() => { inflight = null; });
    return inflight;
}
load();
export function approxIn(lang, mxn) {
    if (!cache)
        return null;
    const code = lang ? LANG_CURRENCY[lang] : "USD";
    if (code === "MXN")
        return null;
    const rate = cache.rates[code];
    if (!rate)
        return null;
    const v = mxn * rate;
    const sym = SYMBOL[code] ?? code;
    // round naturally
    const rounded = v < 1 ? v.toFixed(2) : v < 10 ? v.toFixed(1) : Math.round(v).toString();
    return `≈ ${sym}${rounded} ${code}`;
}
